module.exports = __webpack_public_path__ + "static/05-bc73f6d43bfa0dbf8775ba4e0482240e.jpg";